<script setup lang="ts">
import type { ScaleConfig } from "@/types/legend.types";
import { computed } from "vue";
import ScaleRow from "./ScaleRow.vue";

const props = defineProps<{
  scale: ScaleConfig;
  activeScale?: ScaleConfig | null;
  /** Hauteur forcée en vigueur : elle remplace celle du style actif. */
  forcedSize?: number | "";
}>();

const isActive = computed<boolean>(
  () => props.activeScale?.name === props.scale.name,
);
</script>
<template>
  <div class="dropdown-item" :class="{ active: isActive }">
    <ScaleRow :scale="scale" :forced-size="isActive ? forcedSize : ''" />
  </div>
</template>
